import script from "./AdminOrder.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminOrder.vue?vue&type=script&setup=true&lang=js"

import "./AdminOrder.vue?vue&type=style&index=0&id=11ab0398&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-11ab0398"]])

export default __exports__